import i18n from '../../../../i18n'

import {
  LOGIN_FORM_TYPE_EMAIL,
  LOGIN_FORM_TYPE_PHONE,
} from './LoginForm.constants'

export function isLoginEmailTypeActive(type) {
  return type === LOGIN_FORM_TYPE_EMAIL
}

export function isLoginPhoneTypeActive(type) {
  return type === LOGIN_FORM_TYPE_PHONE
}

export function getLoginFormTabs() {
  return [
    {
      id: LOGIN_FORM_TYPE_EMAIL,
      text: i18n.t('Auth.LoginFormTabEmailKey'),
      tooltip: i18n.t('Auth.LoginFormTabEmailTooltipKey'),
    },
    {
      id: LOGIN_FORM_TYPE_PHONE,
      text: i18n.t('Auth.LoginFormTabPhoneKey'),
      tooltip: i18n.t('Auth.LoginFormTabPhoneTooltipKey'),
    },
  ]
}
